export function deepAwaitMixin(superClass) {
    class DeepAwaitClass extends superClass {
        get childrenToAwait() {
            const children = this.shadowRoot.querySelectorAll('*');
            return Array.from(children).filter((c) => c instanceof DeepAwaitClass);
        }
        get deepUpdateComplete() {
            return Promise.all(this.childrenToAwait.map((c) => c.deepUpdateComplete)).then(() => this.updateComplete);
        }
        updated(_changedProperties) {
            super.updated(_changedProperties);
            this.dispatchEvent(new CustomEvent("deep-update"));
        }
    }
    // Cast return type to the superClass type passed in
    return DeepAwaitClass;
}
//# sourceMappingURL=DeepAwaitMixin.js.map